import { useNavigate } from 'react-router-dom'
import Button from '../../../components/Button'
import Divider from '../../../components/Divider'
import useResize from '../../../hooks/useResize'
import BriefcaseClockIcon from '../../../icons/BriefcaseClockIcon'
import CalendarIcon from '../../../icons/CalendarIcon'
import { transformDateTwo } from '../../../utils'
import { VIEWPORT_LG } from '../../../utils/constants'

const ChallengeCard = ({ name, categoryJob, date, total_videos, id }) => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const navigate = useNavigate()

  return (
    <div className="position-relative">
      <div
        style={{
          width: isMobile ? '100%' : '522px',
        }}
        className="hover-job-offer-card border rounded mb-2 text-on-bg-primary p-2"
      >
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <div className="d-flex align-items-center gap-3">
              <div className="d-flex justify-content-between align-items-start w-100">
                <span
                  className={`${
                    isMobile ? 'font-extra-small' : 'fs-6'
                  }  fw-bold text-on-bg-primary`}
                >
                  {name}
                </span>
              </div>
            </div>
          </div>
        </div>

        <Divider className="bg-on-bg-Tertiary w-100 mt-2 mb-2" />

        <div
          className={`${
            viewportSize[0] <= VIEWPORT_LG ? 'font-extra-small' : ''
          } d-flex flex-column gap-1 mb-2`}
        >
          <div className="d-flex align-items-start gap-1">
            <BriefcaseClockIcon fill="#004949" width={16} height={16} />
            <span className="text-on-bg-secondary font-small-2">
              Tipo de perfil:
            </span>
            <span className="font-small-2">{categoryJob?.name}</span>
          </div>

          <div className="d-flex align-items-start gap-1">
            <CalendarIcon fill="#004949" width={16} height={16} />
            <span className="text-on-bg-secondary font-small-2">
              Publicado:
            </span>
            <span className="font-small-2">{transformDateTwo({ date })}</span>
          </div>
        </div>

        <div className="d-flex flex-lg-row flex-column align-items-center justify-content-between w-100">
          <div className="rounded bg-bg-CTA-primary-selected text-on-bg-CTA-primary-selected px-2 py-1 fontSize10">
            {total_videos} talentos
          </div>
          <Button
            className="btn-bg-white border border-on-bg-primary text-on-bg-primary fontSize14"
            onClick={() => navigate(`/challenge-detail/${id}`)}
          >
            Ver Reto
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ChallengeCard
